import ScrollReveal from "@/components/feature/ScrollReveal";

const technologies = [
  { icon: "ri-cloud-line", name: "AWS & Azure", category: "Cloud" },
  { icon: "ri-shield-keyhole-line", name: "ISO 27001 / NIST", category: "Security" },
  { icon: "ri-code-s-slash-line", name: "React & Node.js", category: "Development" },
  { icon: "ri-database-2-line", name: "PostgreSQL & MongoDB", category: "Database" },
  { icon: "ri-box-3-line", name: "Docker & Kubernetes", category: "DevOps" },
  { icon: "ri-git-branch-line", name: "CI/CD Pipelines", category: "Automation" },
  { icon: "ri-smartphone-line", name: "iOS & Android", category: "Mobile" },
  { icon: "ri-pie-chart-line", name: "Data Analytics", category: "BI" },
  { icon: "ri-more-line", name: "And Others", category: "Custom" },
];

export default function TechStackSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-gray-50 dark:bg-dark-card">
      <div className="px-4 md:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-3 py-1 rounded-full bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold uppercase tracking-wider mb-4">
              Technology Stack
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
              Tools We Master
            </h2>
            <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 max-w-xl mx-auto">
              We work with enterprise-grade technologies that scale with your business.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {technologies.map((tech, i) => (
            <ScrollReveal key={tech.name} delay={(i % 4) + 1}>
              <div className="group p-5 md:p-6 rounded-2xl bg-white dark:bg-dark-bg border border-gray-100 dark:border-dark-border hover:border-brand-200 dark:hover:border-brand-500/30 transition-all duration-300 hover:-translate-y-1 text-center">
                <div className="w-12 h-12 rounded-xl bg-brand-50 dark:bg-brand-500/10 flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${tech.icon} text-xl text-brand-500`} />
                </div>
                <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
                  {tech.name}
                </h3>
                <p className="text-xs text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                  {tech.category}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}